export default function(arr1, arr2) {
    return arr1.filter(function(i) {return arr2.indexOf(i) < 0;});
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/helpers/array-diff.js